export default {
  load_contract: (state, contract) => {
    state['contracts'] = contract
  },
  load_account: (state, account) => {
    state['accounts'] = account
  },
  load_modal: (state, data) => {
    state['modal'] = data
  },
  load_notification: (state, data) => {
    state['notification'] = data
  },
  clear_notification: (state, data) => {
    state['notification'] = data
  }
}
